/* eslint-disable react-hooks/exhaustive-deps */
import {FC, useContext, useState, useEffect, useMemo} from 'react'
import {useQuery} from 'react-query'
import {
  initialQueryState,
  PaginationState,
  QUERIES,
  WithChildren,
} from '../../../../../_dashboard/helpers'
import {useQueryRequest} from './QueryRequestProvider'
import {getAll} from '../../../../services/common_requests'
import { createReservationResponseContext, Reservation, initialReservationQueryResponse } from './_models'

const QueryReservationResponseContext = createReservationResponseContext<Reservation>(initialReservationQueryResponse)
const QueryResponseProvider: FC<WithChildren> = ({children}) => {
  const {state} = useQueryRequest()
  const [query, setQuery] = useState<any>(state)
  const updatedQuery = useMemo(() => state, [state])

  useEffect(() => {
    if (query !== updatedQuery) {
      setQuery(updatedQuery)
    }
  }, [updatedQuery])

  const {
    isFetching: isFetchingReservations,
    refetch: refetchData,
    data: dataResponse,
  } = useQuery(
    `${QUERIES.RESERVATIONS_LIST}-${JSON.stringify(query)}`,
    () => {
      return getAll(query, '/reservations')
    },
    {cacheTime: 0, keepPreviousData: true, refetchOnWindowFocus: false}
  )

  return (
    <QueryReservationResponseContext.Provider
      value={{
        isLoading: isFetchingReservations,
        refetchData,
        dataResponse,
        query,
      }}
    >
      {children}
    </QueryReservationResponseContext.Provider>
  )
}

const useQueryResponse = () => useContext(QueryReservationResponseContext)

const useQueryResponseData = () => {
  const {dataResponse} = useQueryResponse();

  if (!dataResponse) {
    return [];  
  }
  return dataResponse.data;  
}
const useQueryResponsePagination = () => {
  const defaultPaginationState: PaginationState = {
    links: [],
    ...initialQueryState,
  }

  const {dataResponse} = useQueryResponse()
  if (!dataResponse || !dataResponse.payload || !dataResponse.payload.pagination) {
    return defaultPaginationState
  }

  return dataResponse.payload.pagination
}

const useQueryResponseLoading = (): boolean => {
  const {isLoading} = useQueryResponse()
  return isLoading
}

export {
  QueryResponseProvider,
  useQueryResponse,
  useQueryResponseData,
  useQueryResponsePagination,
  useQueryResponseLoading,
}
